// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "@hotwired/stimulus"
// import Sortable from "sortablejs"
import sortable from "html5sortable/dist/html5sortable.es.js"

export default class extends Controller {
  connect() {
    //console.log(sortable)
    sortable('.tasklist', {
      handle: '.sort-handle',
      forcePlaceholderSize: true
    })

    document.querySelector('.tasklist').addEventListener('sortupdate', function(e) {
			console.log('Sortupdate: ', e.detail);
			console.log('Container: ', e.detail.origin.container, ' -> ', e.detail.destination.container);
			console.log('Index: '+e.detail.origin.index+' -> '+e.detail.destination.index);
			console.log('Element Index: '+e.detail.origin.elementIndex+' -> '+e.detail.destination.elementIndex);

      console.log(e.detail.item.id)
    })
    // this.sortable = Sortable.create(document.getElementById("task_4"), {
    //   group: 'shared',
    //   animation: 150,
    //   handle: ".my-handle",
    //   onEnd: this.end.bind(this)
    // })
  }

  // end(event) {
  //   console.log(event)
  //   let id = event.item.dataset.id
  //   let data = new FormData()
  //   data.append("position", event.newIndex + 1)

  //   // Rails.ajax({
  //   //   url: this.data.get("url").replace(":id", id),
  //   //   type: 'PATCH',
  //   //   data: data
  //   // })
  // }
}